module.exports = __webpack_public_path__ + "img/characters.8d670da4.png";